export const formatNumber = (locale: string, value: number, options?: any) => {
  return Intl.NumberFormat(locale, { notation: 'compact', ...options }).format(value);
}
